export { default } from "/Volumes/Files HD/Development/datos-remix/app/routes/index.tsx";